// extracted by mini-css-extract-plugin
export default {"fade-up":"style_fade-up__fxqvW","is-visible":"style_is-visible__RogQO","fade-left":"style_fade-left__I2QTU","loginPopup":"style_loginPopup__L3aI+","marquee":"style_marquee__Tmwxh"};